import { nftSchema } from '@0xtorch/core'
import { z } from 'zod'
import type { LowerHex } from './hex'
import { addressPrimitiveSchema, bigintTextSchema } from './primitive'

export const erc1155TransferSchema = z.object({
  address: addressPrimitiveSchema,
  from: addressPrimitiveSchema,
  logIndex: z.number().int(),
  to: addressPrimitiveSchema,
  tokenId: bigintTextSchema,
  value: bigintTextSchema,
})

export type Erc1155Transfer = z.infer<typeof erc1155TransferSchema>

export const erc1155TokenTransferSchema = erc1155TransferSchema.extend({
  token: nftSchema,
})

export type Erc1155TokenTransfer = z.infer<typeof erc1155TokenTransferSchema>

export type Erc1155NftId = `evm_1155_${number}_${LowerHex}_${bigint}`

export const isErc1155NftId = (id: string): id is Erc1155NftId =>
  /^evm_1155_\d+_0x[0-9a-f]{40}_\d+$/.test(id)
